import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './FencerPage.css'; // Make sure this import stays

function FencerView() {
  const API = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const navigate = useNavigate();

  const passedFencer = location.state?.fencer || null;

  const [fencer, setFencer] = useState(
    passedFencer || {
      id: localStorage.getItem('fencerId') || '',
      name: localStorage.getItem('fencerName') || '',
    }
  );

  const [competitions, setCompetitions] = useState([]);
  const [signedUpCompetitions, setSignedUpCompetitions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (passedFencer) {
      localStorage.setItem('fencerId', passedFencer.id);
      localStorage.setItem('fencerName', passedFencer.name);
    }
  }, [passedFencer]);

  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.backgroundColor = '#000';

    if (fencer.id) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [fencer.id]);

  async function fetchData() {
    setLoading(true);
    try {
      const compRes = await fetch(`${API}/competitions`);
      const allCompetitions = await compRes.json();

      const signupsRes = await fetch(`${API}/fencers/${fencer.id}/signups`);
      const signedUpComps = await signupsRes.json();
  
      const signedUpCompIds = signedUpComps.map(c => c.competition_id);

      const visibleCompetitions = allCompetitions.filter(comp => {
        return comp.active || signedUpCompIds.includes(comp.id);
      });
  
      setCompetitions(visibleCompetitions);
      setSignedUpCompetitions(Array.isArray(signedUpComps) ? signedUpComps : []);
    } catch (err) {
      handleError('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  }
  

  const handleSignUp = async (competitionId) => {
    if (!fencer.id) {
      handleError('You must be logged in as a fencer to sign up.');
      return;
    }

    try {
      const response = await fetch(`${API}/competitions/${competitionId}/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fencerId: fencer.id }),
      });

      if (response.ok) {
        await fetchData();
      } else {
        const errorData = await response.json();
        setErrorMessage('Signup failed: ' + errorData.error);
        setTimeout(() => setErrorMessage(""), 3000);
      }
    } catch (error) {
      handleError('Signup failed: ' + error.message);
    }
  };

  const handleWithdraw = async (competitionId) => {
    const fencerId = Number(localStorage.getItem('fencerId'));
    if (!fencerId) {
      handleError('You must be logged in to withdraw.');
      return;
    }
  
    try {
      const res = await fetch(`${API}/competitions/${competitionId}/fencers/${fencerId}`, {
        method: 'DELETE',
      });
  
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || 'Withdrawal failed');
      }
  
      await fetchData();
    } catch (err) {
      handleError(err.message || err.toString());
    }
  };
  

  const handleError = function (error) {
    setErrorMessage(error);
    setTimeout(() => {
      setErrorMessage("");
    }, 3000);
  };

  if (loading) return <p className="loading-text">Loading competitions...</p>;

  const getSignupInfo = (compId) =>
    signedUpCompetitions.find((c) => c.competition_id === compId);

  return (
    <div className="fencer-page">
      <button className="link-button" onClick={() => navigate('/')}>
        ← Back
      </button>

      <h2 className="greeting">Hello, {fencer.name || 'Fencer'}!</h2>
      <h3 className="subtitle">Active Competitions</h3>
      <div className={errorMessage ? 'error-message' : ''}>
        <p>{errorMessage}</p>
      </div>

      {competitions.length === 0 ? (
        <p className="no-competitions">No active competitions found.</p>
      ) : (
        <ul className="competition-list">
          {competitions.map((comp) => {
            const signup = getSignupInfo(comp.id);
            const hasMat = signup && typeof signup.mat === 'number';

            return (
              <li
                key={comp.id}
                className={`competition-item${hasMat ? ' mat-assigned-glow' : ''}`}
              >
                <div>
                  <strong className="competition-name">{comp.name}</strong>
                  <div className="competition-time">Time: {comp.start_time || 'TBA'}</div>
                </div>

                {!signup && (
                  <button
                    className="signup-button"
                    onClick={() => handleSignUp(comp.id)}
                  >
                    Sign Up
                  </button>
                )}
                {signup && (signup.mat === null || signup.mat === 0) && (
                  <div>
                    <h2 className="signed-up-message">Signed up</h2>
                    <button className='signup-button withdraw-button' onClick={() => handleWithdraw(comp.id)}>Withdraw</button>
                  </div>
                )}
                {signup && typeof signup.mat === 'number' && signup.mat > 0 && (
                  <h2 className="mat-assigned-message">Mat {signup.mat}</h2>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default FencerView;
